import React from "react";
import { appConfig } from "src/config";
import { getMeristemContext } from "src/utils/meristemContext";

export const DisclaimerLink = ({
  href,
  children,
}: {
  href: string;
  children?: React.ReactNode;
}) => (
  <a href={href} className="footer-link" target="_blank" rel="noreferrer">
    {children}
  </a>
);
const DisclaimerLinks = {
  TocLink: `${appConfig.BLOG_DOMAIN}/terms-and-conditions-of-use/`,
  PrivacyLink: `${appConfig.BLOG_DOMAIN}/noom-privacy-policy/`,
  ResearchLink: `${appConfig.BLOG_DOMAIN}/research-policy/`,
  GooglePrivacyLink: "https://policies.google.com/privacy",
  HIPAALink: `${appConfig.BLOG_DOMAIN}/hipaa-notice/`,
  GoogleTocLink: "https://policies.google.com/terms",
  SupportLink: `${appConfig.BLOG_DOMAIN}/support/contact-support`,
  EmailHMSupportLink: "mailto:hmsupport@noom.com",
  EmailSupportLink: "mailto:programsupport@noom.com",
};
const localeSpecificDisclaimerLinks = {
  es: {
    TocLink: "https://web2.noom.com/es/es-tos/",
    PrivacyLink: "https://web2.noom.com/es/es-privacy-policy/",
    ResearchLink: "https://web2.noom.com/es/research-policy-spanish/",
    SupportLink:
      "https://web2.noom.com/es/support/support-premium-features/contact-support/",
    EmailSupportLink: "mailto:programsupport-es@noom.com",
  },
  de: {
    TocLink: "https://web2.noom.com/de/de-tos/",
    PrivacyLink: "https://web2.noom.com/de/de-privacy-policy/",
    ResearchLink: "https://web2.noom.com/de/research-policy-german/",
    SupportLink:
      "https://web2.noom.com/de/support/kundenservice-premium-funktionen/kontaktiere-support/",
    EmailSupportLink: "mailto:support-de@noom.com",
  },
  ja: {
    TocLink: "https://web2.noom.com/jp/jp-tos/",
    PrivacyLink: "https://web2.noom.com/jp/jp-privacy-policy/",
    EmailSupportLink: "mailto:programsupport-ja@noom.com",
  },
};
// Merge locale-specific links with default links
const { language_code } = getMeristemContext();
export const disclaimerUrls: Record<string, string> = {
  ...DisclaimerLinks,
  ...localeSpecificDisclaimerLinks[language_code],
};

// Generate a map of DisclaimerLinks for convenient interpolation of disclaimer links in a <Text /> component.
export const disclaimerLinks: Record<string, typeof DisclaimerLink> =
  Object.entries(disclaimerUrls).reduce((map, [linkName, href]) => {
    // eslint-disable-next-line no-param-reassign
    map[linkName] = <DisclaimerLink href={href} />;
    return map;
  }, {});
